export const quickJournalNightTheme = {
        id: "night",
        label: "Night",
        containerClassName: "QuickJournalContainerNightSkyV4",
        overlay: {
            backgroundColor: `rgb(4, 5, 18)`,
            backgroundImage:
                `linear-gradient(to bottom, rgba(4, 5, 18, 0) 0%, rgba(1, 2, 8, 0.68) 74%, rgb(0, 0, 0) 100%), ` +
                `linear-gradient(to bottom, rgba(22, 34, 62, 0.18) 0%, rgba(18, 27, 52, 0.08) 16%, rgba(7, 11, 28, 0) 42%), ` +
                `radial-gradient(circle at 50% 8%, rgba(118, 149, 214, 0.12), transparent 30%), ` +
                `radial-gradient(circle at 24% 18%, rgba(64, 94, 154, 0.12) 0 10%, transparent 24%), ` +
                `radial-gradient(circle at 76% 16%, rgba(49, 78, 136, 0.10) 0 9%, transparent 22%), ` +
                `radial-gradient(circle at 22% 6%, rgba(182, 120, 230, 0.22), transparent 24%), ` +
                `radial-gradient(circle at 62% 4%, rgba(148, 82, 200, 0.18), transparent 26%), ` +
                `radial-gradient(circle at 78% 12%, rgba(118, 56, 172, 0.14), transparent 20%), ` +
                `radial-gradient(circle at 42% 14%, rgba(94, 40, 152, 0.12), transparent 18%), ` +
                `radial-gradient(circle at top, rgba(217, 194, 106, 0.10), transparent 58%), ` +
                `radial-gradient(circle at 6% 9%, rgba(255,215,120,0.56) 0 1px, transparent 1.8px), ` +
                `radial-gradient(circle at 11% 18%, rgba(255,203,96,0.38) 0 1.2px, transparent 2px), ` +
                `radial-gradient(circle at 18% 8%, rgba(255,222,132,0.50) 0 1px, transparent 1.7px), ` +
                `radial-gradient(circle at 29% 12%, rgba(255,194,78,0.42) 0 1px, transparent 1.8px), ` +
                `radial-gradient(circle at 41% 10%, rgba(255,205,94,0.44) 0 1px, transparent 1.8px), ` +
                `radial-gradient(circle at 53% 7%, rgba(255,228,150,0.52) 0 1.1px, transparent 2px), ` +
                `radial-gradient(circle at 67% 13%, rgba(255,200,88,0.38) 0 1px, transparent 1.8px), ` +
                `radial-gradient(circle at 79% 11%, rgba(255,208,100,0.46) 0 1px, transparent 1.9px), ` +
                `radial-gradient(circle at 92% 8%, rgba(255,214,116,0.43) 0 1px, transparent 1.8px), ` +
                `radial-gradient(circle at 13% 49%, rgba(255,206,98,0.41) 0 1px, transparent 1.8px), ` +
                `radial-gradient(circle at 31% 45%, rgba(255,189,72,0.35) 0 1px, transparent 1.8px), ` +
                `radial-gradient(circle at 46% 41%, rgba(255,204,96,0.39) 0 1px, transparent 1.8px), ` +
                `radial-gradient(circle at 65% 36%, rgba(255,219,128,0.43) 0 1px, transparent 1.8px), ` +
                `radial-gradient(circle at 83% 52%, rgba(255,197,84,0.36) 0 1px, transparent 1.8px), ` +
                `radial-gradient(circle at 25% 62%, rgba(255,211,110,0.44) 0 1px, transparent 1.8px), ` +
                `radial-gradient(circle at 44% 68%, rgba(255,186,66,0.34) 0 1px, transparent 1.8px), ` +
                `radial-gradient(circle at 61% 63%, rgba(255,208,102,0.41) 0 1px, transparent 1.8px), ` +
                `radial-gradient(circle at 78% 60%, rgba(255,202,92,0.37) 0 1px, transparent 1.8px), ` +
                `radial-gradient(circle at 10% 88%, rgba(255,182,58,0.26) 0 0.9px, transparent 1.6px), ` +
                `radial-gradient(circle at 22% 91%, rgba(255,200,86,0.36) 0 1px, transparent 1.7px), ` +
                `radial-gradient(circle at 48% 92%, rgba(255,194,74,0.31) 0 1px, transparent 1.7px), ` +
                `radial-gradient(circle at 69% 93%, rgba(255,207,98,0.35) 0 1px, transparent 1.7px), ` +
                `radial-gradient(circle at 90% 90%, rgba(255,201,88,0.33) 0 1px, transparent 1.7px), ` +
                `radial-gradient(circle at 15% 6%, rgba(200, 148, 255, 0.07) 0 1.6px, transparent 2.8px), ` +
                `radial-gradient(circle at 52% 10%, rgba(172, 112, 238, 0.06) 0 1.4px, transparent 2.4px), ` +
                `radial-gradient(circle at 80% 7%, rgba(156, 88, 214, 0.05) 0 1.2px, transparent 2px), ` +
                `radial-gradient(circle at 38% 20%, rgba(138, 72, 200, 0.04) 0 1px, transparent 1.8px)`,
        },
        backdrop: {
            backgroundColor: "rgb(7, 9, 18)",
            topIos: "calc(100% - 28px)",
            topDefault: "calc(100% - 7px)",
            width: "max(640px, 100vw)",
            height: "280px",
            minHeight: "280px",
            maxHeight: "280px",
            background: `
                radial-gradient(
                    circle 280px at 50% 0px,
                    rgba(248, 226, 154, 0.16) 0%,
                    rgba(232, 196, 104, 0.1) 20%,
                    rgba(208, 171, 86, 0.06) 34%,
                    rgba(27, 39, 62, 0.045) 48%,
                    rgba(7, 16, 31, 0.035) 64%,
                    rgba(0, 0, 0, 0) 100%
                ),
                radial-gradient(
                    circle 180px at 50% 0px,
                    rgba(242, 214, 128, 0.08) 0%,
                    rgba(242, 214, 128, 0.04) 22%,
                    rgba(242, 214, 128, 0) 100%
                ),
                radial-gradient(
                    circle 220px at 50% 18px,
                    rgba(148, 82, 194, 0.16) 0%,
                    rgba(108, 48, 164, 0.10) 28%,
                    rgba(88, 38, 138, 0.04) 48%,
                    rgba(88, 38, 138, 0) 100%
                ),
                linear-gradient(
                    to bottom,
                    rgba(29, 50, 82, 0.08) 0%,
                    rgba(18, 33, 58, 0.05) 10%,
                    rgba(20, 35, 59, 0.12) 23%,
                    rgba(0, 0, 0, 0) 42%
                ),
                linear-gradient(
                    to bottom,
                    rgba(18, 33, 58, 0.16) 0%,
                    rgba(31, 48, 78, 0.58) 18%,
                    rgba(7, 16, 31, 0.9) 54%,
                    rgba(0, 0, 0, 1) 100%
                )`,
            boxShadow:
                "inset 0 10px 30px rgba(255, 226, 145, 0.02), inset 0 -44px 96px rgba(0, 0, 0, 0.72)",
        },
        recentEntry: {
            color: "rgba(244, 236, 214, 0.92)",
            textShadow: "0 0 10px rgba(244, 236, 214, 0.08)",
            timestampColor: "rgba(244, 236, 214, 0.75)",
        },
        input: {
            color: "#f4d35e",
            cursorLow: "#b88a1b",
            cursorMid: "#7ea61f",
            cursorHigh: "#d9822b",
        },
        heatmap: {
            containerColor: "rgba(255, 236, 191, 0.92)",
            cellBackground: (level: number) => {
                if (level <= 0) return "rgba(255, 236, 191, 0.06)";
                if (level >= 4) return "rgba(255, 214, 102, 0.95)";
                if (level === 3) return "rgba(247, 194, 74, 0.88)";
                if (level === 2) return "rgba(214, 160, 33, 0.8)";
                return "rgba(110, 83, 24, 0.62)";
            },
            cellBoxShadow: "0 0 8px rgba(184, 134, 11, 0.08)",
            flashBoxShadow: "0 0 12px rgba(255, 255, 255, 0.95)",
            hoverOutline: "1px solid rgba(255, 255, 255, 0.96)",
            inactiveOpacity: 0.34,
            activeOpacity: 1,
        },
        toggle: {
            color: "darkgoldenrod",
            opacity: 0.6,
            shadow: "drop-shadow(0px 0px 5px black)",
            transform: "rotate(-135deg)",
        },
        switcher: {
            border: "rgba(255, 226, 145, 0.22)",
            background: "rgba(12, 14, 20, 0.42)",
            text: "rgba(244, 236, 214, 0.86)",
            activeBackground: "rgba(243, 195, 86, 0.22)",
            activeText: "rgba(255, 243, 210, 0.98)",
            activeBorder: "rgba(243, 195, 86, 0.52)",
        },
    } as const;
